import {Box} from "@material-ui/core";
import styled from "styled-components";

export const STSearchBar = styled(Box)`
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 16px;
  width: 100%;
`;
